import type { DolfinRpc } from '../../rpc'

export const getStatementPaidRollbackStatus = (
  hasStatementApprovalFlow: boolean,
  hasPayoutValidationFlow: boolean
): 'approved' | 'open' =>
  hasStatementApprovalFlow || hasPayoutValidationFlow ? 'approved' : 'open'

export class StatementPaidNotificationError extends Error {
  constructor(
    readonly rollbackFailed: boolean,
    cause: unknown
  ) {
    super('Statement payment notification could not be created', { cause })
  }
}

export const notifyStatementPaid = async ({
  rpcClient,
  currentUserId,
  organizationId,
  rollback,
  statementIds
}: {
  rpcClient: DolfinRpc
  currentUserId: string
  organizationId: number
  rollback: () => Promise<void>
  statementIds: number[]
}): Promise<void> => {
  if (statementIds.length === 0) return

  try {
    await rpcClient.createStatementPaidNotifications({
      statementIds,
      organizationId,
      actorId: currentUserId
    })
  } catch (error) {
    console.error('Failed to create statement paid notifications:', { error, statementIds })
    try {
      await rollback()
    } catch (rollbackError) {
      console.error('Failed to roll back statement status after notification insert error:', {
        error,
        rollbackError,
        statementIds
      })
      throw new StatementPaidNotificationError(true, rollbackError)
    }
    throw new StatementPaidNotificationError(false, error)
  }
}
